import ApiClient from "../api-client"

const optionsPerPage = 10;
const _cache = {};

const loadCountriesOptions = async (search, page, props) => {
    const cacheKey = props.myDataInvoiceType || 'all';

    if (!_cache[cacheKey]) {
        const object = {
            quickSearch: "",
            pageNo: 1,
            sortBy: "alpha2",
            order: "asc",
            pageSize: 300,
        };
        const result = await ApiClient.getCountriesPage(object, props.myDataInvoiceType);
        _cache[cacheKey] = result.data.objectList.map(element => ({
            label: props.t(element.alpha2),
            value: element.alpha2,
            model: element
        }));
    }

    const allOptions = _cache[cacheKey];

    const filtered = search
        ? allOptions.filter(o => o.label.toLowerCase().includes(search.toLowerCase()))
        : allOptions;

    const fromIndex = (page - 1) * optionsPerPage;
    const pageOptions = filtered.slice(fromIndex, fromIndex + optionsPerPage);
    const hasMore = fromIndex + optionsPerPage < filtered.length;

    return { options: pageOptions, hasMore };
};

export default loadCountriesOptions;
